/*
 *  build_name.js — KanoogiMain (kanoogimain image / "km" service) build label.
 *
 *  Bump BUILD_NAME below before each meaningful rebuild.  Webpack pulls this
 *  file into the client bundle (via optionpanel.js) so the name is baked into
 *  the dist/*.bundle.js and rides whatever container image the user deploys
 *  next — local docker build, QA, or PROD.  The same string therefore appears
 *  on the lower-left chip of every alpha tester, letting them confirm a
 *  hard-refresh actually picked up the new bundle.
 *
 *  Visibility: rendered only when the signed-in account passes the alpha-cohort
 *  gate (client-side gate is kanoogi.canPlay, set by signedin.SignedIn()).  Non-
 *  alpha users never see this chip.
 *
 *  Naming: short, evocative, tied loosely to what changed in this build
 *  ("Slim Pickings" for the dropdown narrowing, "Hailing Frequencies" for the
 *  Desktop /api/health work, etc.).  Mirrors the same pattern in
 *  OmniServer/build_name.cpp (SERVER_BUILD_NAME), Desktop/build_name.js
 *  (BUILD_NAME), and MacClient/Sources/Util/BuildName.swift (clientBuildName).
 */

export const BUILD_NAME='Clear Horizons';
